import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Capture the install prompt as early as possible so one-tap install works on any page.
window.addEventListener("beforeinstallprompt", (e) => {
  e.preventDefault();
  window.__fhapasInstallPrompt = e;
  window.dispatchEvent(new Event("fhapas-install-available"));
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30_000, refetchOnWindowFocus: false, retry: 1 },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <QueryClientProvider client={queryClient}>
    <App />
  </QueryClientProvider>
);

// Register the PWA service worker so FHAPAS is installable on desktop & mobile.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker.js").catch(() => {});
  });
}
